import axios from "axios";
import {getBackendURL, httpResponse, httpResponseError} from "../../fn";

/**
 * Зарегистрировать пользователя в сайнми
 * @returns {HttpResponseError|HttpResponseOk}
 */
export const signmeRegistrationPerson = async (subjectId) => {
  const result = await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/sign/registration/person/${subjectId}`, {}, {
      withCredentials: true,
      headers: {
        'content-type': 'application/json',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  })

  return result;
}

/**
 * Удаляет регистрацию в Сайнми
 * @returns {HttpResponseError|HttpResponseOk}
 * @param subjectId
 */
export const signmeDeleteRegistrationPerson = async (subjectId) => {
  return await new Promise((resolve) => {
    axios.delete(`${getBackendURL()}/sign/registration/person/${subjectId}`, {}, {
      withCredentials: true,
      headers: {
        'content-type': 'application/json',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  });
}

/**
 * Активировать пользователя в сайнми
 * @param subjectId
 * @returns {HttpResponseError|HttpResponseOk}
 */
export const signmeActivate = async (subjectId) => {
  return await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/sign/registration/person/activate/${subjectId}`, {}, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  });
}

/**
 * Проверить регистрацию и наличие ЭЦП у пользователи
 * @param subjectId
 * @returns {HttpResponseError|HttpResponseOk}
 */
export const checkEdsInSignme = async (subjectId) => {
  return await new Promise((resolve) => {
    axios.get(`${getBackendURL()}/sign/check/${subjectId}`, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  });
}

/**
 * Зарегистрировать пользователя в сайнми
 * @param subjectId
 * @returns {HttpResponseError|HttpResponseOk}
 */
export const uploadRegistrationDocs = async (subjectId) => {
  return await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/sign/registration/person/docs/${subjectId}`, {}, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  });
}

/**
 * Загрузить документ субъекта для выпуска ЭЦП
 * @param docType
 * @param formData
 * @param subjectId
 * @returns {Promise<unknown>}
 */
export const uploadSignMeDocument = async (docType, formData, subjectId) => {
  return await new Promise((resolve) => {
    axios.post(`${getBackendURL()}/sign/upload/${docType}/subject/${subjectId}`, formData, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(httpResponse(response.data))
    }).catch((error) => {
      resolve(httpResponseError(error));
    });
  });
}

/**
 * Удалить документ из заявления на выпуск ЭЦП
 * @returns {Promise<UploadFileResult>}
 */
export const deleteSignMeDocument = async (docType, subjectId) => {
  const result = await new Promise((resolve) => {
    axios.delete(`${getBackendURL()}/sign/documents/${docType}/subject/${subjectId}`, {
      withCredentials: true,
      headers: {
        'content-type': 'multipart/form-data',
      },
    }).then((response) => {
      resolve(response.data)
    });
  })

  return result;
}